module.exports = __webpack_public_path__ + "static/media/pro.4b9ce663.png";